module.exports = __webpack_public_path__ + "img/ai-full-page.e4884703.png";